export interface Data<T> {
    data: T[];
    total: number;
}

export interface Pagination<T> extends Data<T> {
    page: number;
    pageSize: number;
}